<template lang="pug">
div(:class="{ 'myanmar-login': myanmarLogin }")
  .bg-login(data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("ui.login") }}
        .login-content
          template(v-if="isCaptchaShow")
            Captcha(@click="captchaValidate")
          template(v-else)
            b-form.margin-bottom-0(@submit.stop.prevent="loginSession" novalidate :disabled="!submission.success")
              .form-group.m-b-20
                DebounceInput(
                  required
                  autofocus
                  type="text"
                  v-model.trim.lazy="$v.username.$model"
                  :placeholder='$t("ui.username")'
                  :disabled="loading"
                  :maxLength="$v.username.$params.maxLength.max"
                  :dirty="$v.username.$dirty"
                  :error="$v.username.$error"
                )
                ValidateResult(:value="$v.username" :name="$t('ui.username')")
              .form-group.m-b-20
                b-input-group.input-group-sm
                  DebounceInput(
                    required
                    :type=" (isPWShown) ? 'password' : 'text'"
                    v-model.trim.lazy="$v.password.$model"
                    :placeholder='$t("ui.password")'
                    :disabled="loading"
                    :maxLength="$v.password.$params.maxLength.max"
                    :dirty="$v.password.$dirty"
                    :error="$v.password.$error"
                  )
                  .input-group-append(style="cursor: pointer;")
                    b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                      i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                  ValidateResult(:value="$v.password" :name="$t('ui.password')")
              ul.navbar-nav.navbar-right.w-100.text-center.m-b-20
                b-nav-item-dropdown.login-dropdown(menu-class='navbar-language', no-caret='')
                  template(slot='button-content')
                    template(v-if="$store.getters.language == 'en'")
                      span.flag-icon.flag-icon-us.mr-1(title='us')
                      span.name.mr-1 {{ $t("language.english").toUpperCase() }}
                    template(v-if="$store.getters.language == 'zh'")
                      span.flag-icon.flag-icon-cn.mr-1(title='zh')
                      span.name.mr-1 {{ $t("language.simplified_chinese").toUpperCase() }}
                    template(v-if="$store.getters.language == 'vi'")
                      span.flag-icon.flag-icon-vn.mr-1(title='vi')
                      span.name.mr-1 {{ $t("language.vietnamese").toUpperCase() }}
                    template(v-if="$store.getters.language == 'th'")
                      span.flag-icon.flag-icon-th.mr-1(title='th')
                      span.name.mr-1 {{ $t("language.thai").toUpperCase() }}
                    template(v-if="$store.getters.language == 'jp'")
                      span.flag-icon.flag-icon-jp.mr-1(title='jp')
                      span.name.mr-1 {{ $t("language.japanese").toUpperCase() }}
                    template(v-if="$store.getters.language == 'kh'")
                      span.flag-icon.flag-icon-kh.mr-1(title='kh')
                      span.name.mr-1 {{ $t("language.combodia").toUpperCase() }}
                    b.caret
                  b-dropdown-item(@click="setLanguage('en')")
                    span.flag-icon.flag-icon-us.mr-1(title='us')
                    span.text-dark {{ $t("language.english") }}
                  b-dropdown-item(@click="setLanguage('zh')")
                    span.flag-icon.flag-icon-cn.mr-1(title='zh')
                    span.text-dark {{ $t("language.simplified_chinese") }}
                  b-dropdown-item(@click="setLanguage('vi')")
                    span.flag-icon.flag-icon-vn.mr-1(title='vi')
                    span.text-dark {{ $t("language.vietnamese") }}
                  b-dropdown-item(@click="setLanguage('th')")
                    span.flag-icon.flag-icon-th.mr-1(title='th')
                    span.text-dark {{ $t("language.thai") }}
                  b-dropdown-item(@click="setLanguage('jp')")
                    span.flag-icon.flag-icon-jp.mr-1(title='jp')
                    span.text-dark {{ $t("language.japanese") }}
                  b-dropdown-item(@click="setLanguage('kh')")
                    span.flag-icon.flag-icon-kh.mr-1(title='kh')
                    span.text-dark {{ $t("language.combodia") }}
              .form-group.m-b-20
                b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .login-buttons
                SubmitButton.btn.btn-block.btn-lg(icon="fa fa-sign-in-alt" :text="$t('ui.login')" variant="primary" :loading="loading" isModal=false)
              .m-t-20
                small.text-muted {{ version }}
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import Captcha from "@/components/modal/captcha";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    Captcha
  },
  data: function() {
    return {
      isCaptchaShow: false,
      isPWShown: true,
      username: "",
      password: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    version() {
      return "Production @ Version 202205012302";
    },
    myanmarLogin() {
      return config.myanmarLogin;
    }
  },
  mounted: function() { },
  validations: {
    username: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50)
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
    },
    setLanguage(lang){
      this.$store.dispatch("layout/setLanguage", lang);
    },
    captchaValidate: function() {
      this.isCaptchaShow = false;
      this.login();
    },
    loginSession: function() {
      let login_id = this.username;
      this.loading = true;
      this.$store
        .dispatch("user/loginSession", { login_id })
        .then(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            let isCaptcha = response.data[0].abbc.substring(15,16);
            if(isCaptcha == "1") {
              this.isCaptchaShow = isCaptcha;
            } else {
              this.login();
            }
          }
        })
        .catch(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    login: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let login_id = this.username;
        let password = this.password;
        this.loading = true;
        this.$store
          .dispatch("user/login", { login_id, password })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              // let currencyCode = this.$store.getters.getAccountCurrency
              // if(currencyCode == "MMK") {
              //   $('meta[name="viewport"]').prop('content', 'width=1440')
              // } else {
              //   $('meta[name="viewport"]').prop('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
              // }
              if(response.redirect == "loginSession") {
                // let isLoginChecked = response.data[0].a;
                let timer = response.data[0].b;
                if(timer) {
                  if(timer < 43200) {
                    this.$swal({
                      title: this.$t("ui.status"),
                      // text: this.$t("message.relogin_seconds", {"timer" : timer}) + '/br' + this.$t("message.relogin_seconds", {"timer" : timer}),
                      html: this.$t("message.relogin_seconds", { "timer": timer }) + '<br><br>' + this.$t("message.relogin_tooltips", { "timer": timer }),
                      type: "warning",
                      allowOutsideClick: true
                    })
                  } else {
                    this.$swal({
                      title: this.$t("ui.status"),
                      text: this.$t("message.relogin_hours", {"timer" : timer/60/60}),
                      type: "warning",
                      allowOutsideClick: true
                    })
                  }
                } else {
                  this.$swal({
                    title: this.$t("ui.status"),
                    text: this.$t("message.relogin_hours", {"timer" : 24}),
                    type: "warning",
                    allowOutsideClick: true
                  })
                }
              } else {
                if (response.redirect === "/overview") {
                  this.$helpers.checkPartner();
                }
                this.$router.push(response.redirect);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
};
</script>
